'use client'

import WhatToExpectSection from '@/components/whatToExpect'
import type { Step } from '@/components/whatToExpect'
import { CalendarDays, Mail, Home, Video, ShieldCheck } from 'lucide-react'

const steps: Step[] = [
  {
    icon: CalendarDays,
    title: 'Easy Online Booking',
    description:
      'Schedule your online appointment through our secure patient portal or by contacting our office, just as you would for an in-person visit.',
  },
  {
    icon: Mail,
    title: 'Receive Your Secure Link',
    description:
      "Prior to your appointment, you'll receive a confidential link to join your video session. No complicated software downloads are typically required.",
  },
  {
    icon: Home,
    title: 'Find a Private Space',
    description:
      "Choose a quiet, private location where you feel comfortable and won't be interrupted for the duration of your session.",
  },
  {
    icon: Video,
    title: 'Connect with Your Provider',
    description:
      'At your scheduled time, simply click the link to join the secure video call with your ReACH psychiatrist or therapist.',
  },
  {
    icon: ShieldCheck,
    title: 'Receive Quality Care',
    description:
      'Engage in your session just as you would in person, receiving the same high standard of compassionate and expert care.',
  },
]

const HowItWorks: React.FC = () => (
  <section id="how-it-works" className="bg-emerald-50">
    <WhatToExpectSection
      steps={steps}
      mainTitle="Your Seamless Online Experience: How it Works"
      mainDescription="Accessing care online with ReACH is straightforward and secure:"
    />
  </section>
)

export default HowItWorks
